// extracted by mini-css-extract-plugin
export default {"modal":"JY8XGYGdnkNKBGIIqerYQ","buttons":"_25YQJvMNzLYOGeazN2gBA1","no":"_103-IRCviI5yAvkQu6zFWh","yes":"_2qvuJt8d2dvJV0My5uiaz1"};